module.exports = __webpack_public_path__ + "static/BoardOversight-8cbb6b47ef5520f73d1f253df42056db.png";